import { useHasUnreadChat } from '../../hooks/useHasUnreadChat';

export default function ChatButton({ onClick }) {

  const hasUnread = useHasUnreadChat();

  return (
    <button className="chat-button" onClick={onClick} aria-label="Open chat">
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z" />
        <path d="M7 9h10v2H7zm0-3h10v2H7z" />
      </svg>
      {hasUnread && <span className="chat-dot" />}
    </button>
  );
}